export const ShoppingBagSVG = () => {
  return (
    <svg width='1em' height='1em' viewBox='0 0 18 18' fill='none'>
      <path
        d='M4.75 1.5L2.5 4.5V15C2.5 15.3978 2.65804 15.7794 2.93934 16.0607C3.22064 16.342 3.60218 16.5 4 16.5H14.5C14.8978 16.5 15.2794 16.342 15.5607 16.0607C15.842 15.7794 16 15.3978 16 15V4.5L13.75 1.5H4.75Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M2.5 4.5H16' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12.25 7.5C12.25 8.29565 11.9339 9.05871 11.3713 9.62132C10.8087 10.1839 10.0456 10.5 9.25 10.5C8.45435 10.5 7.69129 10.1839 7.12868 9.62132C6.56607 9.05871 6.25 8.29565 6.25 7.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
